export const SET_THEME = 'Control/SET_THEME'
export const SET_AUDIT = 'Control/SET_AUDIT'
export const SET_AUDIT_MISSION = 'Control/SET_AUDIT_MISSION'
export const POP_SNACKBAR = 'Control/POP_SNACKBAR'
export const SET_SNACKBAR = 'Control/SET_SNACKBAR'
